// const roles = {
// 	USER: "DEVELOPER",
// 	ADMIN: "ADMIN",
// 	SUPER: "SUPERUSER"
// };

import {roles} from "./ability";
import PropTypes from "prop-types";
import dayjs from "dayjs";

const types = [
	{
		code: roles.PINBIKER,
		name: "utente",
	},
	{
		code: roles.ADMIN,
		name: "amministratore",
	},
	{
		code: roles.MANAGER,
		name: "superutente",
	},
];

const adminResources = {
	VENUE: "venues",
	DEVELOPER: "developers",
	USER: "users",
};

const resources = {
	BEACONS: "beacons",
	EVENTS: "events",
	OUTDOOR: "outdoor",
	POI: "poi",
	PATH: "paths",
	ASSET: "assets",
	DEVELOPER: "developers",
	MAPS: "maps",
	REALTIME: "realtime",
	ANALYTICS: "stats",
	TOURS: "tours",
	CONTACT_TRACING: "contact_tracing",
};
let isSuperUser = user => user.userType === roles.MANAGER || isAdmin(user);

let isAdmin = user => user.userType === roles.ADMIN;

let getRoleName = role => types.find(t => t.code === role).name;

//Se superutente posso assegnare tutte le risorse, se Admin posso assegnare tutte le risorse che mi sono state assegnate, con l'eccezione di quelle riservate agli admin
// let getUserResources = (user, venue) => isSuperUser(user) ? Object.values(resources) : user.authorizations.filter(a => a.venue === venue.id).map(a => a.resource).filter(r => !Object.values(adminResources).find(e => e === r));

export {
	adminResources,
	resources,
	roles,
	types,
	getRoleName,
	isAdmin,
	isSuperUser,
	// getUserResources
};


export const EditPermissionType = Object.freeze({
	ACHIEVEMENT: {
		key: 'ACHIEVEMENT',
		canCreatePermissionKey: 'canCreateAchievement',
		deriveState: (achievement) => ({
			isAchievementActive: dayjs(achievement.endDate).endOf('day') > Date.now(),
			isAchievementStarted: dayjs(achievement.startDate) < Date.now(),
			isAchievementClosed: !!achievement.closed

		}),
		definePermissions: (achievement, isAdmin, state) => ({
			canEditLogo: isAdmin && state.isAchievementActive,
			canEditName: isAdmin && state.isAchievementActive,
			canEditDescription: isAdmin && state.isAchievementActive,
			canEditStartDate: isAdmin && !state.isAchievementStarted,
			canEditEndDate: isAdmin && state.isAchievementActive,
			canEditRepetitions: isAdmin && state.isAchievementActive,
			canEditDuration: isAdmin && state.isAchievementActive,
			canEditValue: isAdmin && state.isAchievementActive,
			canEditTarget: isAdmin && state.isAchievementActive,
			canEditFilter: isAdmin && state.isAchievementActive,
			canEditFilterValue: isAdmin && state.isAchievementActive,
			canEditType: isAdmin && state.isAchievementActive,
			canEditUsernameIcon: isAdmin ,
			canCloneAchievement: isAdmin,
			canDeleteAchievement: isAdmin,
			canCloseAchievement: isAdmin && !state.isAchievementClosed
		})
	},
	RANKING: {
		key: 'RANKING',
		canCreatePermissionKey: 'canCreateRanking',
		deriveState: (ranking) => ({
			isRankingActive: dayjs(ranking.endDate).endOf('day') > Date.now(),
			isRankingStarted: dayjs(ranking.startDate) < Date.now(),
			isAwardRankingsAssigned: !!ranking.awardsAssigned,
			isRankingClosed: !!ranking.closed,
		}),
		definePermissions: (ranking, isAdmin, state) => ({
			canEditTitle: isAdmin && state.isRankingActive,
			canEditValue: isAdmin && state.isRankingActive,
			canEditFilter: isAdmin,
			canEditFilterValue: isAdmin && state.isRankingActive,
			canEditStartDate: isAdmin && !state.isRankingStarted,
			canEditEndDate: isAdmin && state.isRankingActive,
			canEditRepetitions: isAdmin && state.isRankingActive,
			canCloseRanking: isAdmin && !state.isRankingClosed,
			canDeleteRanking: isAdmin && !state.isAwardRankingsAssigned
		})
	}
});

defineEditPermissions.propTypes = {
	isAdmin: PropTypes.bool.isRequired,
	editPermissionType: PropTypes.oneOf(Object.values(EditPermissionType)).isRequired,
	collection: PropTypes.array.isRequired
};

export function defineEditPermissions(isAdmin, editPermissionType, collection = []) {
	const permissionsById = {};
	for (const element of collection) {
		const elementState = editPermissionType.deriveState(element);
		permissionsById[element.id] = editPermissionType.definePermissions(element, isAdmin, elementState);
	}
	permissionsById[editPermissionType.canCreatePermissionKey] = isAdmin;
	return permissionsById;
}